import React, { useEffect, useRef } from 'react'
import styled from 'styled-components';
import { lightThemeColors } from '../../assets/style/colors';
import OutlinedButton from '../generic/OutlinedButton';
import { Link, useOutletContext } from 'react-router-dom';
import PrimaryButton from '../generic/PrimaryButton';
import Asset1 from "../../assets/imgs/analytics-white.webp"
import { ReactComponent as GridDecoration } from "../../assets/decorations/decorationIntro.svg";

const UsecaseIntro = () => {

  const viewRef = useRef();



  return (
    <FullPageContainer>
      <Container ref={viewRef}>

        <TextWrapper>
          <Title>
            Smart, effective ways to grow your app with Grovs
          </Title>
          <Subtitle>
            Grovs helps web teams drive engagement, increase conversions, and gain clear insight into user journeys with smart linking, automated messaging, and precise tracking.
          </Subtitle>
          <Line>

            <PrimaryButton
              text={"Get Started"}
              bgVariant={lightThemeColors.background}
              styled={{ color: lightThemeColors.darkColor }}
              onClick={() =>
                window.open("https://app.grovs.io/register", "_blank")
              }
            />

            <Link style={{ textDecoration: "none" }} to={"/contact"}>
              <OutlinedButton
                text={"Request a demo"}
                variant={lightThemeColors.lightColor}
              />
            </Link>
          </Line>
        </TextWrapper>
        <DecorationWrapper>
          <img src={Asset1} alt='analytics-white' />
        </DecorationWrapper>
      </Container>
      <BlurContainer>
        <BlurCircle />
      </BlurContainer>
      <GridDecotrationWrapper>
        <GridDecoration />
      </GridDecotrationWrapper>
    </FullPageContainer>
  )
}

export default UsecaseIntro

const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.landingPagePrimaryBackground};
  position: relative;
  overflow:hidden;
    justify-content: center;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 2;
padding:150px 100px 80px;
  gap: 40px;
  position: relative;

  @media (max-width: 990px) {
    flex-direction: column; 
padding:80px 20px 60px;
  }
`;

const Title = styled.h1`
  color: ${lightThemeColors.lightColor};
  font-size: 48px;
  font-weight: 700;
  line-height: 50px;
  text-align: left;
  z-index: 2;
  span {
    color: rgba(21, 49, 91, 0.2);
  }

  @media (max-width: 990px) {
    font-size: 35px;
    line-height: 40px;
    text-align: center;
  }
`;
const SecondaryTitle = styled.h2`
 color:${lightThemeColors.lightColor};
  font-size: 30px;
  font-weight: 700;
  line-height: 38px;
  margin-top: 0px;
  z-index: 2;
  @media (max-width: 990px) {
    font-size: 24px;
    line-height: 28x;
  }
`
const Subtitle = styled.h3`
  color:${lightThemeColors.lightColor};
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  margin-top: 0px;
  max-width: 700px;
  z-index: 2;
  @media (max-width: 990px) {
    text-align: center;
  }
`;

const DecorationWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  width:100%;
  margin-left:auto;
  img {
    display: flex;
    height: 100%;
    width: 100%;
   
  }
    @media(max-width: 990px){
    margin-left:unset;
    }

  @media (max-width: 550px) {
    display: none;
  }
`;
const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  z-index: 1;
    width:100%;
  @media (max-width: 990px) {
    gap: 20px;
    align-items: center;
  }
`;
const Line = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;
`;

const BlurCircle = styled.div`
  width: 700px;
  height: 100%;
  border-radius: 50%;
  background: rgba(91, 104, 223, 1);
  will-change: filter;
  filter: blur(120px);
  -webkit-filter: blur(120px);;
  left: -20px;
  opacity: 0.5;
  position: absolute;
`;

const GridDecotrationWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
  svg {
    display: flex;
    margin-left: auto;
    margin-right: auto;
  }
`;

const BlurContainer = styled(Container)`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  z-index: 1;
  position: absolute;
`;
